import React from 'react';

const IndicatorLocation = ({
                               indicatorColor = null,
                           }) => {

    return (
        <div>
            {
                indicatorColor &&
                <div className={'notif-icon'} style={{color: indicatorColor || 'grey'}}>
                    <i className="fas fa-exclamation-triangle"/>
                </div>
            }
        </div>
    )
};

export default IndicatorLocation;